export default "/fonts/vendor/lightgallery/lg.ttf?747d038541bfc6bb8ea9118bed9c160e";